import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入 flexible 用于 rem 适配
import 'lib-flexible'

// 引入 Vant 组件库
import Vant from 'vant'
import 'vant/lib/index.css'

// 注册 Vant
Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
